<template>
  <v-card class="mx-auto" max-width="400">
    <v-toolbar
      :color="selectedTemplate ? 'grey darken-4' : 'primary'"
      dark
    >
      <v-btn
        v-if="selectedTemplate"
        icon
        @click="selectedTemplate = null"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ selectedTemplate ? `Apply [ ${selectedTemplate.name} ]` : 'Query Parameters' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-scale-transition>
        <v-btn
          v-if="selectedTemplate"
          icon
          @click="applyDmsTemplate"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-scale-transition>
    </v-toolbar>
    <v-card-text>
      <v-select
        v-model="selectedTemplate"
        :items="dmsTemplates"
        label="Apply Query Param Template"
        outlined
        dense
      ></v-select>
    </v-card-text>

    <v-list dense subheader>
      <v-subheader>Select a query parameter for the Datasource</v-subheader>
      <v-divider></v-divider>

      <v-list-group v-for="category in categories" :key="category" value="true" multiple>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ category | capitalize }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="queryParam in queryParamsByCategory(category)"
          :key="queryParam.name"
          link
          active=true
        >
          <v-list-item-action>
            <v-checkbox v-model="localSelectedQueryParamNames" :value="queryParam.name" color="primary"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="queryParam.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
import { DmsDatasourceApi } from '@/services'
const R = require('ramda')

export default {
  props: {
    availableQueryParams: { type: Array, required: true },
    selectedQueryParams: { type: Array, required: true }
  },
  data () {
    return {
      localSelectedQueryParamNames: [],
      selectedTemplate: null,
      dmsTemplatesData: []
    }
  },
  computed: {
    categories: function () {
      const allCategories = this.availableQueryParams.map(
        queryParam => queryParam['category']
      )
      return [...new Set(allCategories)].sort() // use set to make unique list then convert back to array with spread
    },
    dmsTemplates: function () {
      return this.dmsTemplatesData.map(dmsTemplate => {
        return { text: dmsTemplate.name, value: dmsTemplate }
      })
    }
  },
  watch: {
    selectedQueryParams: function (newSelected, oldSelected) {
      this.$logger.trace('Syncing selectedQueryParams with localSelectedQueryParamNames')

      const newSelectedNames = newSelected.map(qp => qp.name)

      const additions = R.difference(newSelectedNames, this.localSelectedQueryParamNames)
      const removals = R.difference(this.localSelectedQueryParamNames, newSelectedNames)

      if (additions.length > 0) {
        additions.forEach(qp => {
          this.$logger.trace('Adding Selected Item local: ', qp)
          this.$set(this.localSelectedQueryParamNames, this.localSelectedQueryParamNames.length, qp)
        })
      }

      if (removals.length > 0) {
        removals.forEach(qp => {
          this.$logger.trace('Removing Selected Item local: ', qp)
          let existingIdx = this.localSelectedQueryParamNames.indexOf(qp)
          this.localSelectedQueryParamNames.splice(existingIdx, 1)
        })
      }
      if ((additions === removals) && additions === 0) {
        this.$logger.trace('Sync selectedQueryParams Complete without change!')
      }
    },
    localSelectedQueryParamNames: function (newSelected, oldSelected) {
      const additions = R.difference(newSelected, oldSelected)
      const removals = R.difference(oldSelected, newSelected)

      if (additions.length > 0) {
        additions.forEach(qp => this.$emit('select-query-param', qp))
      }

      if (removals.length > 0) {
        removals.forEach(qp => this.$emit('remove-query-param', qp))
      }
    }
  },
  methods: {
    queryParamsByCategory: function (category) {
      return this.availableQueryParams.filter(
        query => query.category === category
      ).sort((a, b) => a.name.localeCompare(b.name))
    },
    loadDmsTemplates: function () {
      DmsDatasourceApi.fetchDmsDatasourceTemplates()
        .then(dsTemplatesResp => {
          this.dmsTemplatesData = dsTemplatesResp.data
        })
        .catch(error => {
          this.$logger.error('Error loading DMS Templates.', error.message)
          this.$flash({
            showClose: true,
            message: `Error loading Dms Templates. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    },
    applyDmsTemplate: function () {
      this.$emit('apply-dms-template', this.selectedTemplate)
      this.selectedTemplate = null
    }
  },
  mounted () {
    this.loadDmsTemplates()
  }
}
</script>
